import { ArrowSquareOut } from "@phosphor-icons/react"
import { type MouseEvent } from "react"

import { CellProductImage } from "~/components/planning/ProductTable/ProductCellRenderers"
import { IconButton } from "~/components/reusable/Button"
import { CellIconGrid } from "~/components/reusable/CellIconGrid"
import { cn } from "~/utils/helpers"

interface ProductCellContentProps {
  imageUrl?: string
  title: React.ReactNode
  subtitle: string
  icons?: React.ReactNode[]
  alert?: React.ReactNode
  className?: string
  onOpen?: (e: MouseEvent) => void
}

export const ProductCellContent = ({
  imageUrl,
  title,
  subtitle,
  icons,
  alert,
  className,
  onOpen,
}: ProductCellContentProps) => {
  return (
    <div className={cn("relative flex items-center h-[40px]", className)}>
      <CellProductImage imageUrl={imageUrl} />
      <div className="flex-1 min-w-0 leading-5 overflow-hidden pl-4 pr-1">
        <div className="label-sm truncate">{title}</div>
        <div className="text-fg-muted paragraph-sm truncate">{subtitle}</div>
      </div>
      {alert && <div className="shrink-0 max-w-[120px] pr-1 whitespace-normal">{alert}</div>}
      <CellIconGrid icons={icons} />
      {onOpen && (
        <div className="open-cell-button flex items-center">
          <IconButton
            variant="neutral"
            size="sm"
            title="Open"
            onClick={(e) => {
              e.stopPropagation()
              onOpen(e)
            }}
          >
            <ArrowSquareOut size={16} />
          </IconButton>
        </div>
      )}
    </div>
  )
}
